import type { SportProfile } from '@/types'

export const lacrosseMens: SportProfile = {
  id: 'lacrosse-mens-outdoor',
  sport: 'lacrosse',
  gender: 'mens',
  environment: 'outdoor',
  label: "Men's Field Lacrosse",
  emoji: '🥍',
  playersOnField: 10,
  contactLevel: 'full',
  hasShotClock: false,
  periods: { label: 'Quarter', count: 4, durationMinutes: 15 },
  positions: [
    { key: 'goalie', label: 'Goalie', shortLabel: 'G', maxOnField: 1 },
    { key: 'defense', label: 'Defenseman', shortLabel: 'D', maxOnField: 3 },
    { key: 'midfield', label: 'Midfielder', shortLabel: 'M', maxOnField: 3 },
    { key: 'attack', label: 'Attackman', shortLabel: 'A', maxOnField: 3 },
    { key: 'lsm', label: 'Long Stick Midfielder', shortLabel: 'LSM', maxOnField: 1 },
    { key: 'fogo', label: 'Face-Off / Get-Off', shortLabel: 'FOGO', maxOnField: 1 },
  ],
  stats: [
    { key: 'goal', label: 'Goal', shortLabel: 'G' },
    { key: 'assist', label: 'Assist', shortLabel: 'A' },
    { key: 'shot', label: 'Shot', shortLabel: 'SH' },
    { key: 'shot_on_goal', label: 'Shot on Goal', shortLabel: 'SOG' },
    { key: 'ground_ball', label: 'Ground Ball', shortLabel: 'GB' },
    { key: 'turnover', label: 'Turnover', shortLabel: 'TOV' },
    { key: 'caused_turnover', label: 'Caused Turnover', shortLabel: 'CT' },
    { key: 'save', label: 'Save', shortLabel: 'SV' },
    { key: 'faceoff_win', label: 'Faceoff Win', shortLabel: 'FOW', statType: 'faceoff-win' },
    { key: 'faceoff_loss', label: 'Faceoff Loss', shortLabel: 'FOL', statType: 'faceoff-loss' },
    { key: 'penalty', label: 'Penalty', shortLabel: 'PEN', statType: 'card' },
    { key: 'violation', label: 'Violation', shortLabel: 'VIO', statType: 'violation' },
    { key: 'clear', label: 'Clear', shortLabel: 'CLR' },
    { key: 'opp_shot', label: 'Opp Shot', shortLabel: 'OPP', statType: 'opp-shot' },
  ],
}
